import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  type SxProps
} from "@mui/material"
import type { Control, FieldPath, FieldValues } from "react-hook-form"
import { Controller } from "react-hook-form"

export type CheckBoxProps<T extends FieldValues> = {
  label?: string
  labelPosition?: "start" | "end" | "top" | "bottom"
  name: FieldPath<T>
  control: Control<T>
  disabled?: boolean
  defaultValue?: boolean
  sx?: SxProps
  disableRipple?: boolean
}

export default function CheckBox<T extends FieldValues>({
  name,
  control,
  label,
  labelPosition = "end",
  defaultValue,
  disabled,
  disableRipple,
  sx
}: CheckBoxProps<T>) {
  return (
    <Controller<FieldValues>
      name={name.toString()}
      control={control as unknown as Control<FieldValues>}
      render={({ field: { onChange, value } }) => (
        <>
          <FormControl component="fieldset">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={onChange}
                    value={value as FieldValues}
                    disableRipple={disableRipple}
                    defaultChecked={defaultValue}
                    disabled={disabled}
                    sx={{ ...sx }}
                  />
                }
                label={label}
                labelPlacement={labelPosition}
              />
            </FormGroup>
          </FormControl>
        </>
      )}
    />
  )
}
